<template>
  <div class="my-account layout">
    <div class="account-logo">
      <img class="logo" src="../../assets/imgs/account-logo.png" alt="Sisley Paris" />
    </div>
    <div class="account-info">
      <div class="bg-images">
        <img class="color-bg" src="../../assets/imgs/account-bg.png" alt="Sisley Paris" />
        <img class="flower-bg" src="../../assets/imgs/gettyimages-large.png" alt="Sisley Paris" />
      </div>
      <div class="account-fields ms-row">
        <div class="col-xs-6 col-md-2">
          <div class="info-title">您的会员身份</div>
          <div class="info-content">{{userFullInfo.customer_level}}</div>
        </div>
        <div class="col-xs-6 col-md-2">
          <div class="info-title">您的会员积分</div>
          <div class="info-content">{{userFullInfo.total_points || 0}}分</div>
        </div>
        <div class="col-md-2 info" v-if="userFullInfo.base_info">
          <div class="info-title-bold">您的个人信息</div>
          <div class="info-content">
            <p>{{userFullInfo.base_info.name}}</p>
            <p>{{userFullInfo.base_info.birth}}</p>
            <p>{{userFullInfo.base_info.phone}}</p>
            <!-- <span class="edit" @click="toEditProfile">编辑</span> -->
          </div>
        </div>
        <div class="col-md-2 address">
          <div class="info-title-bold">您的地址簿</div>
          <div class="info-content">
            <template v-if="userFullInfo.shipping_address">
              <p>{{userFullInfo.shipping_address.name}} {{userFullInfo.shipping_address.mobile}}</p>
              <p>{{userFullInfo.shipping_address.province}}{{userFullInfo.shipping_address.city}}{{userFullInfo.shipping_address.district}}{{userFullInfo.shipping_address.address_detail}}</p>
              <span class="edit" @click="toAddAddress">新增地址</span>
            </template>
            <template v-else>
              <p>您还没有地址</p>
              <span class="edit" @click="toAddAddress">新增地址</span>
            </template>
          </div>
        </div>
      </div>
      <div class="welcome-info" v-if="userFullInfo.base_info">
        <div class="welcome-msg">您好，{{userFullInfo.base_info.name}}{{userFullInfo.base_info.sex=="M"?"先生":"女士"}}，</div>
        <div class="txt-lines">
          <div class="txt-line">欢迎使用您的Sisley帐户。</div>
        </div>
        <span class="logout" @click="logout">退出</span>
      </div>
    </div>
    <div class="content">
      <div class="sidebar">
        <div class="user-logout" v-if="userFullInfo.base_info">
          <div class="user-name">{{userFullInfo.base_info.name}}</div>
          <span class="logout" @click="logout">退出</span>
        </div>
        <div class="navbar">
          <router-link v-for="(item, index) in navBar" :key="index"
            :class="['nav-item', item.routeName == current || (item.routeName == 'MallWrap' && ['MallList', 'MallHistory'].indexOf(current) != -1) ? 'active' : '' ]"
            :to="{ name: item.routeName }">{{item.name}}</router-link>
        </div>
      </div>
      <div class="primary">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import types from '@/store/types';
import api from '@/utils/api';

export default {
  data() {
    return {
      navBar: [
        { name: "我的账户", routeName: "Myaccount" },
        { name: "我的订单", routeName: "MyOrders" },
        { name: "我的会员中心", routeName: "Club" },
        { name: "我的个人信息", routeName: "Profile" },
        { name: "我的地址簿", routeName: "Address" },
        { name: "我的礼券", routeName: "Coupon" },
        { name: "我的足迹", routeName: "History" },
        { name: "我的收藏", routeName: "Favorites" },
        // { name: "积分商城", routeName: "MallWrap" }
      ],
      current: ""
    };
  },
  created() {
    if (this.$route.name) {
      this.current = this.$route.name;
    }
    if (this.isLogin && !this.$store.state.userFullInfo) {
      this.loadSource();
    }
  },
  methods: {
    loadSource() {
      api[types.GET_ACCOUNT_INFO]({
        key: 'account'
      }).then(res => {
        if (res.code == 1) {
          let { base_info, customer_level, total_points, shipping_address, benefit_info, coupon_list, order_list, active_info  } = res.data;
          this.$store.commit('saveUserFullInfo', {
            base_info,
            customer_level,
            total_points,
            shipping_address,
            benefit_info,
            coupon_list,
            order_list,
            active_info,
            original_level: res.data.original_level || 0
          });
        } else if (res.code != 2) {
          this.$message({ message: res.message, iconCls: "failure" });
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    logout() {
      this.$store.dispatch(types.LOGOUT, () => {
        this.$router.replace({ path: "/" });
      });
    },
    toEditProfile() {
      this.$router.push({ path: "/myaccount/profile" });
    },
    toAddAddress() {
      this.$router.push({ path: "/myaccount/address" });
    }
  },
  computed: {
    isLogin() {
      return this.$store.state?.isLogin;
    },
    userFullInfo() {
      return this.$store.state?.userFullInfo || { base_info: this.$store.state.userInfo };
    }
  },
  watch: {
    $route(e) {
      this.current = e.name;
    }
  }
};
</script>

<style lang="scss" scoped>
  .text-bold { font-weight: 700 !important; }
  .my-account {
    .account-logo {
      height: 77px; display: flex; justify-content: center; align-items: center; background: #FFFFFF;
      .logo { width: 160px; height: auto; }
    }
    .account-info {
      width: 100%; height: 272px; overflow: hidden; background: #F9F9F9; position: relative;
      .bg-images {
        .flower-bg { position: absolute; top: 0; right: 0; }
        .color-bg { position: absolute; bottom: -68px; left: 0; transition: bottom 0.2s ease-in; }
      }
      .account-fields {
        position: absolute; top: 2rem; left: 0; right: 0; bottom: 0;
        .col-md-2 { display: flex; flex-direction: column; align-items: center; }
        .info-title, .info-title-bold { color: #333; margin-bottom: 0.375rem; }
        .info-title { font-size: 0.75rem; font-weight: 400; }
        .info-title-bold { font-size: 1.125rem; font-weight: 500; }
        .info-content {
          font-weight: 500; color: #6f836e; font-size: 1.25rem; line-height: 28px;
          p { font-size: 0.75rem;  color: #333;  margin-bottom: 0.625rem; }
          .edit { font-size: 0.75rem;  color: #333; text-decoration: underline; cursor: pointer; }
        }
        .info, .address { display: none; }
      }
      .welcome-info {
        width: calc(100% - 2rem); height: 136px; position: absolute; bottom: 0; left: 1rem; background: #FFFFFF; border-radius:4px 4px 0px 0px; padding: 1rem;
        .welcome-msg { font-size: 14px; color: #000000; font-weight: 700; line-height: 20px; margin: 1rem 0 14px 0; }
        .txt-lines {
          font-size: 12px; color: #575757; text-align: left; line-height: 20px;
        }
        .logout { font-size: 14px; color: #000000; text-decoration: underline; display: inline-block; margin-top: 1rem; cursor: pointer; }
      }
    }
    .content {
      display: flex; flex-direction: column; background: #FFFFFF;
      .sidebar {
        margin-top: 1.375rem;
        .user-logout { display: none; }
        .navbar {
          padding: 1rem; white-space: nowrap; overflow-x: scroll;
          .nav-item {
            margin: 0 1rem; font-size: 14px; color: #575757; text-decoration: none; position: relative;
            &:after {
              content: ""; position: absolute; top: 0; right: -1rem; height: 100%; width: 1px; background: #000000;
            }
            &:first-child { margin-left: 0; }
            &:last-child {
              margin-right: 0;
              &:after { content: none; }
            }
            &.active { color: #000000; font-weight: 700; box-shadow: 0px 2px 0px 0px #000000; }
          }
        }
      }
      .primary { margin-top: 10px; width: 100%; }
    }
  }
@media only screen and (min-width: 48rem) {
  .my-account {
    .account-info {
      .bg-images {
        .color-bg { bottom: -250px; }
      }
      .account-fields { top: 3rem; }
    }
  }
}
@media only screen and (min-width: 64rem) {
  .my-account {
    .account-logo {
      justify-content: flex-end;
    }
    .account-info {
      height: 251px;
      .bg-images {
        .color-bg { display: none; }
      }
      .account-fields {
        .info, .address {
          display: block;
          .info-title-bold, .info-content { width: 100%; }
        }
      }
      .welcome-info { display: none; }
    }
    .content {
      flex-direction: row;
      .sidebar {
        width: 11.875rem; min-width: 11.875rem; margin-right: 3.75rem;
        .user-logout { display: block;
          font-size: 14px; color: #666666; width: 5.25rem; margin-left: 3.1875rem; padding: 0.6875rem 0; border-bottom: 1px solid #DFDFDF;
          .user-name {
            color: #000000;
          }
          .logout {
            font-size: 12px; text-decoration: underline; cursor: pointer;
          }
        }
        .navbar {
          overflow: hidden; padding: 0; white-space: normal;
          .nav-item {
            margin: 0; display: inline-block; width: 100%; padding: 0.6875rem 0 0.6875rem 3.1875rem;
            &:after { content: none; }
            &.active { color: #FFFFFF; font-weight: 400; box-shadow: none; background: #4C6149; }
          }
        }
      }
      .primary { width: calc(100% - 15.625rem); }
    }
  }
}
@media only screen and (min-width: 75rem) {
}
</style>